import 'bootstrap/dist/css/bootstrap.min.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from 'src/App';

if (import.meta.env.DEV) {
  const devAuthToken = import.meta.env.VITE_AUTH_TOKEN as string | undefined;
  if (devAuthToken && !sessionStorage.getItem('AUTH_TOKEN')) {
    sessionStorage.setItem('AUTH_TOKEN', JSON.stringify(devAuthToken));
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
